import React, { useState } from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Chip from "@mui/material/Chip";
import CommonButton from "../CommonButton";
import Grid from "@mui/system/Unstable_Grid/Grid";
import Checkbox from "@mui/material/Checkbox";
import ListItemText from "@mui/material/ListItemText";
import CancelIcon from "@mui/icons-material/Cancel";
import { makeStyles } from "@material-ui/core";
import { Typography } from "@mui/material";

const usePlaceholderStyles = makeStyles((theme) => ({
  placeholder: {
    color: "#5E6366",
  },
}));

const Placeholder = ({ children }) => {
  const classes = usePlaceholderStyles();
  return <div className={classes.placeholder}>{children}</div>;
};
export default function VendorSelect({
  options,
  value = [],
  MenuButtons,
  sx,
  afterSx,
  padding,
  placeholder,
  required = false,
  label,
  onChange = () => {},
}) {
  const [showSelect, setShowSelect] = useState(false);
  const MenuProps = {
    PaperProps: {
      style: {
        maxWidth: "fit-content",
        width: "fit-content",
        backgroundColor: "#EBEEF8",
        ".MuiMenu-list": {
          maxWidth: "min-content",
        },
      },
    },
  };
  const style = {
    ...sx,
    // color: selectedOption === "Select" ? "#B0B0B0" : "#000000",
    // fontWeight: selectedOption === "Select" ? "normal" : "bold",
    // fontSize: fontSize || "1.5rem",
    border: value?.length !== 0 ? "1px solid #5570F1" : "none",
    fontSize: "1.2rem",
    borderRadius: "4px",
    height: "auto",
    backgroundColor: value?.length !== 0 ? "#FFFFFF" : "#EBEEF8",
    ".MuiSelect-select": {
      padding: padding || "9px",
    },
    ".MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      border: 0,
    },
    ".MuiSvgIcon-root ": {
      fontSize: "3rem",
      color: "#7C7C7C",
    },
    ".MuiChip-root .MuiChip-deleteIcon": {
      fontSize: "1.2rem",
      color: "#E42125",
    },
    ...afterSx,
  };

  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    onChange(typeof value === "string" ? value.split(",") : value);
  };

  const chipHandler = () => {};

  const handleDelete = (clickValue) => {
    if (value && Array.isArray(value)) {
      const updatedValue = value?.filter((item) => item !== clickValue);
      onChange(updatedValue);
    }
  };

  const handleResetClickVendor = (e) => {
    onChange([]);
  };

  const handleApplyClickVendor = (e) => {
    setShowSelect(false);
  };

  return (
    <div>
      <FormControl sx={{ m: 1, width: "100%" }}>
        <Box sx={{ display: "flex", gap: "0.2rem", marginBottom: "0.5rem" }}>
          <Typography sx={{ fontSize: "1.2rem", color: "#3A3A3A" }}>
            {label}
          </Typography>
          {required && (
            <Typography sx={{ fontSize: "1.2rem", color: "#E42125" }}>
              *
            </Typography>
          )}
        </Box>
        <Select
          labelId="demo-multiple-chip-label"
          id="demo-multiple-chip"
          multiple
          displayEmpty
          sx={style}
          value={value}
          open={showSelect}
          onOpen={() => setShowSelect(true)}
          onClose={() => setShowSelect(false)}
          onChange={handleChange}
          renderValue={(selected) =>
            value?.length !== 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 0.5,
                  width: "100%",
                  borderRadius: "0.5rem",
                }}
              >
                {selected?.map((value, index) => (
                  <Chip
                    key={value}
                    label={value}
                    clickable
                    deleteIcon={
                      <CancelIcon
                        sx={{ fontSize: "small" }}
                        onMouseDown={(event) => event.stopPropagation()}
                      />
                    }
                    onDelete={(index) => handleDelete(value)}
                    onClick={chipHandler}
                    sx={{
                      ".MuiChip-label": {
                        padding: "0.1rem 1rem 0.1rem 0.5rem",
                      },
                      backgroundColor: "#E2F1FF",
                      fontSize: "1.2rem",
                      height: "auto",
                    }}
                  />
                ))}
              </Box>
            ) : (
              <Placeholder>{placeholder}</Placeholder>
            )
          }
          MenuProps={MenuProps}
        >
          {options.map((name, index) => (
            <MenuItem key={name} value={name} disableRipple>
              <ListItemText
                sx={{ ".MuiListItemText-primary": { fontSize: "1.2rem" } }}
                primary={name}
              />
              <Checkbox
                sx={{
                  "&.Mui-checked": {
                    color: "#E42125",
                  },
                }}
                disableRipple
                checked={value?.includes(name) ? true : false}
              />
            </MenuItem>
          ))}
          {MenuButtons && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "1rem",
                mb: "1rem",
              }}
            >
              <Grid container spacing={1}>
                <Grid item>
                  <CommonButton
                    onClick={handleResetClickVendor}
                    label="Reset"
                    fontSize="0.8rem"
                    borderRadius="1rem"
                    backgroundColor={"#FFFFFF"}
                    isColor
                    isHover
                    hoverColor={"#FFFFFF"}
                    textColor={value?.length !== 0 ? "#E42125" : "#7C7C7C"}
                    sx={{
                      padding: "0px 5px 0px 5px",
                      border:
                        value?.length !== 0
                          ? "1px solid #E42125"
                          : "1px solid #7C7C7C",
                    }}
                  />
                </Grid>
                <Grid item>
                  <CommonButton
                    onClick={handleApplyClickVendor}
                    label="Apply"
                    isColor
                    backgroundColor={
                      value?.length !== 0 ? "#E42125" : "#7C7C7C"
                    }
                    textColor={"#FFFFFF"}
                    fontSize="0.8rem"
                    borderRadius="1rem"
                    isHover
                    hoverColor={value?.length !== 0 ? "#E42125" : "#7C7C7C"}
                    sx={{
                      padding: "0px 5px 0px 5px",
                      border:
                        value?.length !== 0
                          ? "1px solid #E42125"
                          : "1px solid #7C7C7C",
                    }}
                  />
                </Grid>
              </Grid>
            </Box>
          )}
        </Select>
      </FormControl>
    </div>
  );
}
